import { render, staticRenderFns } from "./recusaVersao.vue?vue&type=template&id=a893e0c8"
import script from "./recusaVersao.vue?vue&type=script&lang=js"
export * from "./recusaVersao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports